
import Vue from "vue";
import { InboxreaderService } from "@/services/inboxreader-service";
import { InboxreaderLabel } from "@/utils/purchase/inboxreader-label";
import { InboxreaderPurchaseFile } from "@/utils/purchase/inboxreader-purchase-file";

export default Vue.extend({
	data(){
		return {
			saving: false
		};
	},
	props: {
		file: {
			type: Object as ()=>InboxreaderPurchaseFile,
			required: true
		},
		labels: {
			type: Array as ()=>InboxreaderLabel[],
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		isAssigned(label:InboxreaderLabel):boolean{
			return this.file.Labels.some(l=>l.ID == label.ID);
		},
		async toggle(label:InboxreaderLabel){
			if (this.saving) return;
			this.saving = true;
			try{
				let i = this.file.Labels.findIndex(l=>l.ID == label.ID);
				if (i == -1) {
					await InboxreaderService.assignLabel(label.ID, [this.file.ID]);
					this.file.Labels.push(new InboxreaderLabel(label.getJSON()));
				} else {
					await InboxreaderService.unassignLabel(label.ID, [this.file.ID]);
					this.file.Labels.splice(i, 1);
				}
			}finally{
				this.saving = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
